import { Component, Input } from '@angular/core';

/** Compact presentation bands; the host owns navigation, commands and authorization. */
@Component({
  selector: 'ez-workspace-toolbar',
  standalone: true,
  template: `
    <section
      class="toolbar"
      [class.navigation]="kind === 'navigation'"
      [class.actions]="kind === 'actions'"
      [attr.aria-label]="label"
    >
      <div class="toolbar-row">
        <div class="toolbar-start"><ng-content select="[barStart]" /></div>
        <div class="toolbar-end"><ng-content select="[barEnd]" /></div>
      </div>
      <div class="toolbar-feedback"><ng-content select="[barFeedback]" /></div>
    </section>
  `,
  styles: [
    `
      :host {
        display: block;
        min-width: 0;
        container: workspace-toolbar / inline-size;
      }
      .toolbar {
        border-bottom: 1px solid var(--ui-border-subtle-color, ButtonBorder);
      }
      .toolbar-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px 8px;
        min-height: 32px;
        padding: 3px 8px;
      }
      .toolbar-start,
      .toolbar-end {
        display: flex;
        align-items: center;
        min-width: 0;
      }
      .toolbar-end {
        margin-left: auto;
      }
      .toolbar-feedback:empty {
        display: none;
      }
      .navigation {
        background: var(--ui-workspace-navigation-background-color, ButtonFace);
        color: var(--ui-workspace-navigation-text-color, ButtonText);
      }
      .actions {
        background: var(--ui-surface-muted, ButtonFace);
        color: var(--ui-text-strong-color, CanvasText);
      }
      .actions .toolbar-row {
        min-height: 32px;
      }
      @container workspace-toolbar (max-width: 600px) {
        .toolbar-row {
          padding-inline: 12px;
          gap: 6px 12px;
          flex-wrap: wrap;
        }
        .actions .toolbar-start,
        .actions .toolbar-end {
          width: 100%;
        }
        .actions .toolbar-end {
          margin-left: 0;
        }
      }
    `,
  ],
})
export class WorkspaceToolbarComponent {
  @Input() kind: 'navigation' | 'actions' = 'actions';
  @Input() label = 'Workspace actions';
}
